import React from "react";
import { X, CheckCircle } from "lucide-react";
import { useSuccess } from './SuccessContext';
import HoverSlider from './HoverSlider';
import StackCards from './StackCards';
import Footer from './Footer';
import DigitalElitesCard from './DigitalElitesCard';
import Header from './Header';
import HeroSection from './HeroSection';

function LandingPage() {
  const { showSuccess, successMessage, clearSuccess } = useSuccess();

  return (
    <>
      <Header />
      {/* Success Notification */}
      {showSuccess && (
        <div className="fixed top-4 right-4 z-50 max-w-md bg-green-50 border border-green-200 rounded-lg shadow-lg p-4 animate-fade-in">
          <div className="flex items-start">
            <CheckCircle className="w-6 h-6 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-green-800 font-medium">Success!</p>
              <p className="text-green-700 text-sm mt-1">{successMessage}</p>
            </div>
            <button
              onClick={clearSuccess}
              className="ml-4 text-green-600 hover:text-green-800 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      )}

      <HeroSection />

      {/* Stack Cards with navigation */}
      <StackCards />
      <DigitalElitesCard />
      <HoverSlider />
      <Footer />
    </>
  );
}

export default LandingPage;